import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from "@angular/core";
import { SharedModule } from "../../shared/shared.module";
import { SharedService } from "src/app/services/shared.service";
import { NzPopoverModule } from "ng-zorro-antd/popover";
import { NzModalService } from "ng-zorro-antd/modal";
import { NgClass } from "@angular/common";
import { CopyLinkModalComponent } from "@shared/common-components/copy-link-modal/copy-link-modal.component";

export interface ShareHeaderBreadcrumb {
  project?: string;
  title: string;
  stageBadge?: string;
  stageBadgeClass?: string;
}

export interface ShareHeaderAspectRatio {
  id: number;
  ratio: string;
}

@Component({
  selector: "app-share-header",
  templateUrl: "./share-header.component.html",
  styleUrls: ["./share-header.component.scss"],
  standalone: true,
  imports: [SharedModule, NzPopoverModule, NgClass],
})
export class ShareHeaderComponent implements OnChanges {
  @Input() breadcrumb: ShareHeaderBreadcrumb = { title: "" };
  @Input() user: any = null;
  @Input() commentCount = 0;
  @Input() commentsOpen = false;
  @Input() hideCommentsToggle = false;
  @Input() share_id = "";
  @Input() asset_type = "";
  @Input() asset_id: number | string = "";
  @Input() video_id: number | string = "";
  @Input() showDownload = false;
  /** Share for review links made without dAIrector branding (Studio plan and up): no logo. */
  @Input() unbranded = false;
  @Input() downloading = false;
  @Input() aspectRatioOptions: ShareHeaderAspectRatio[] = [];
  @Input() selectedAspectRatioId: number | null = null;

  @Output() commentsToggle = new EventEmitter<void>();
  @Output() downloadClick = new EventEmitter<void>();
  @Output() aspectRatioSelect = new EventEmitter<number>();

  constructor(
    public sharedService: SharedService,
    private modalService: NzModalService,
  ) {}
  onCommentsClick(): void {
    this.commentsToggle.emit();
  }

  logout(): void {
    this.sharedService.externallogout(this.asset_type, this.share_id);
  }

  openCopyLinkModal(): void {
    this.modalService.create({
      nzTitle: "Share this review",
      nzContent: CopyLinkModalComponent,
      nzFooter: null,
      nzWrapClassName: "common-modal-design copy-link-modal",
      nzCentered: true,
      nzWidth: 480,
      nzData: {
        asset_type: this.asset_type,
        asset_id: this.asset_id,
        video_id: this.video_id,
      },
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["breadcrumb"]) {
      this.breadcrumb = changes["breadcrumb"].currentValue ?? { title: "" };
    }
    if (changes["user"]) {
      this.user = changes["user"].currentValue;
    }
  }
}
